
import { Toast, PullRefresh, IndexBar, IndexAnchor } from "vant";
Vue.use(Toast, PullRefresh, IndexBar, IndexAnchor);
import { Component, Vue } from "vue-property-decorator";
import { AllGameList, userGameList } from "@/req/game";
import pinyin from "wl-pinyin";
import classify from "./components/classify.vue";
@Component({
  components: { classify },
})
export default class Logout extends Vue {
  public isLoading = false;
  public barActive = "";
  public barFlag = false;
  public serachInpFlag = false;
  public inpActive = false; // 搜索框
  public imgEmpty = false;
  public tabType = 0;
  public char = "";
  public keyword = "";
  public typeId: any = {
    versionId: "",
    tagId: "",
  };
  public gameName = "";
  public isShowPhptoPopup = false;
  public allGameList = {};
  public serachData: any = [];
  public recentlyGame: any = [];
  public setitme: any = "";
  public alphabetsList = [
    "#",
    "A",
    "B",
    "C",
    "D",
    "E",
    "F",
    "G",
    "H",
    "J",
    "K",
    "L",
    "M",
    "N",
    "P",
    "Q",
    "R",
    "S",
    "T",
    "W",
    "X",
    "Y",
    "Z",
    "1",
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9",
  ];
  public navList = [
    {
      id: 0,
      name: "全部",
    },
    {
      id: 1,
      name: "ios可以玩",
    },
    {
      id: 2,
      name: "三端都能玩",
    },
  ];
  public indexList: any = [];
  public isIOs = false;

  public mounted() {
    //   url截取token
    // const obj: any = this.$fn.parseQuery(window.location.href);
    if (this.$fn.cookies.getIsios()) {
      this.isIOs = true;
    }
  }

  public created() {
    this.getAllGameList();
    this.getUserGameList();
  }
  // 获取全部游戏
  public async getAllGameList() {
    const obj = {
      client_type: this.tabType,
      char: this.char,
      keyword: "",
      version_id: this.typeId.versionId,
      tag_id: this.typeId.tagId,
    };
    const res = await AllGameList(obj);
    if (res.code == 200) {
      this.allGameJsonDispose(res);
    }
  }
  public async getSerachGameList() {
    const obj = {
      client_type: this.tabType,
      char: this.char,
      keyword: this.keyword,
      version_id: this.typeId.versionId,
      tag_id: this.typeId.tagId,
    };
    const res = await AllGameList(obj);
    if (res.code == 200) {
      this.onSerchGame(res);
    }
  }
  // 数据处理
  public allGameJsonDispose(res) {
    const AllContactPerson = {};
    this.alphabetsList.map((val) => {
      AllContactPerson[val] = [];
      res.data.game_list.data.map((item) => {
        let num = pinyin.getFirstLetter(item.game_name).substring(0, 1);
        if (!this.alphabetsList.includes(num)) {
          num = "#";
        }
        if (num == val) {
          AllContactPerson[val].push(item);
        }
      });
    });
    for (const key in AllContactPerson) {
      // 去除属性为空数组的对象
      if (AllContactPerson[key].length == 0) {
        delete AllContactPerson[key];
      }
    }
    this.allGameList = AllContactPerson;
    this.indexList = Object.keys(AllContactPerson);
  }
  // 获取 最近在玩
  public async getUserGameList() {
    const res = await userGameList();
    if (res.code == 200) {
      this.recentlyGame = res.data.data;
    }
  }
  public onBtnType(val) {
    this.tabType = val.id;
    this.getAllGameList();
  }
  public selectChar(val) {
    this.barActive = val;
    this.barFlag = true;
    setTimeout(() => {
      this.barFlag = false;
    }, 1000);
  }
  // 获取焦点
  public serachInp() {
    this.inpActive = true;
  }
  // 取消
  public onCancel(val) {
    this.keyword = "";
    if (val === "cancelSerach") {
      this.serachInpFlag = false;
      this.imgEmpty = false;
      this.inpActive = false;
      this.getAllGameList();
    } else if (val !== "cancelSerach") {
      if (!this.imgEmpty) {
        this.serachInpFlag = false;
        this.inpActive = false;
        this.getAllGameList();
      }
    }
  }
  // 搜索回车事件
  public onSerachGame() {
    this.imgEmpty = true;
  }
  // 搜索事件
  public onChangeGame() {
    if (this.keyword === "") {
      this.serachInpFlag = false;
    }
    clearTimeout(this.setitme),
      (this.setitme = setTimeout(() => {
        if (this.keyword === "") {
          this.getAllGameList();
          return;
        }
        this.getSerachGameList();
      }, 200));
  }
  public onSerchGame(res) {
    this.imgEmpty = false;
    if (this.keyword.length === 0) return;
    this.serachData = res.data.game_list;
    if (!(this.serachData.data.length === 0)) {
      // 搜索结果不为空
      this.serachInpFlag = true;
      this.serachData.data.map((item) => {
        // 搜索匹配字体颜色
        if (item.game_name.substr(0, this.keyword.length) === this.keyword) {
          const str1 = item.game_name.slice(0, this.keyword.length);
          const str2 = item.game_name.slice(
            this.keyword.length,
            item.game_name.length
          );
          item.game_html = `<span style="color: #C18F3A">${str1}</span><span>${str2}</span>`;
        }
      });
    } else {
      this.serachInpFlag = false;
    }
  }
  // 关闭弹层
  public closePopup(event) {
    this.isShowPhptoPopup = event;
    this.getAllGameList();
  }
  public confirmData(val) {
    this.typeId.versionId = val.versionId;
    this.typeId.tagId = val.tagId;
  }
  public onRefresh() {
    setTimeout(() => {
      this.getAllGameList();
      Toast("刷新成功");
      this.isLoading = false;
    }, 1000);
  }
}
